export default {
  // '工作台': '工作台2'
  '设备名称': '设备名称',
  '设备数量': '设备数量',
  '报警信息': '报警信息',
  '用户数量': '用户数量',
  '故障设备数': '故障设备数',
  '设备报警率': '设备报警率',
  '设备状态占比': '设备状态占比',
  '使用设备': '使用设备',
  '故障设备': '故障设备',
  
  '电压': '电压',
  '电流': '电流',
  '确定要禁用该用户吗': '确定要禁用该用户吗',
  '确认': '确认',
  '单次并网充电电量': '单次并网充电电量',
  '累计并网充电电量': '累计并网充电电量',
}
